"use client";
import React from 'react';

const AllNewsFilter = ({ filterValue, setFilterValue }) => {
    return (
        <select 
        className="explore-news-filter-np"
        value={filterValue}
        onChange={(e) => setFilterValue(e.target.value)}
      >
        <option value="All">All</option>
        <option value="Investment">Investment</option>
        <option value="Market Trends">Market Trends</option>
        <option value="Expert Insights">Expert Insights</option>
      </select>
    );
};

export default AllNewsFilter;